import { render, staticRenderFns } from "./CategoryLocation.vue?vue&type=template&id=50c1ce5d&scoped=true"
import script from "./CategoryLocation.vue?vue&type=script&lang=js"
export * from "./CategoryLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1ce5d",
  null
  
)

export default component.exports